import { render, staticRenderFns } from "./LomBankDetailsList.vue?vue&type=template&id=0173a551"
import script from "./LomBankDetailsList.vue?vue&type=script&lang=js"
export * from "./LomBankDetailsList.vue?vue&type=script&lang=js"
import style0 from "./LomBankDetailsList.vue?vue&type=style&index=0&id=0173a551&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports